import React from 'react';

interface LoadingIconProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
}

export const LoadingIcon: React.FC<LoadingIconProps> = ({ 
  className = "", 
  size = "md" 
}) => {
  const sizeClasses = {
    sm: "w-4 h-4",
    md: "w-6 h-6",
    lg: "w-8 h-8"
  };

  return (
    <div className={`relative ${sizeClasses[size]} ${className}`}>
      <div className="absolute w-full h-full rounded-full border-2 border-t-transparent border-blue-500 animate-spin"></div>
      <div className="absolute w-full h-full rounded-full border-2 border-l-transparent border-r-transparent border-blue-300 animate-ping opacity-30"></div>
    </div>
  );
};